// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"59c25693","239":"3e7b3089","453":"a9814408","833":"123aeaed","834":"84e5e1e3"}[chunkId] + ".chunk.js";
};